<template>
  <v-list two-line>
    <app-notfound v-if="!contactChats.length && !appLoading"/>
    <template v-else v-for="(chat, index) in contactChats">
      <v-list-tile
        v-ripple
        :class="{'list-item--selected': currentChat.id === chat.id}"
        :key="chat.id"
        @click="select(chat.id)"
        avatar>

        <div class="pa-2">
          <app-avatar :id="chat.participant.avatar" :size="48" :isOnline="chat.participant.isOnline" />
        </div>

        <v-list-tile-content class="pl-2">
          <v-list-tile-title>{{chat.participant.displayname}}</v-list-tile-title>
          <v-list-tile-sub-title>{{chat.lastMessage}}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <!-- <v-list-tile-action-text>{{t.lastMsgTime}}</v-list-tile-action-text> -->
          <div class="unread-info">
            <span class="caption pr-2">{{chat.lastMessageTime}}</span>
            <v-chip v-if="chat.unreadCount" small color="red" class="white--text">
              {{chat.unreadCount}}
            </v-chip>
          </div>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider :key="index"/>
    </template>
  </v-list>
</template>

<script>
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';
import {mapState} from 'vuex';

export default {
  data() {
    return {};
  },

  computed: {
    ...mapState({
      appLoading: state => state.appLoading,
      currentChat: state => state.chat.currentChat
    }),

    ...mapGetters('chat', {
      contactChats: 'contactChats'
    })
  },

  methods: {
    ...mapActions('chat', {
      switchChat: 'switchChat'
    }),

    select(chatId) {
      this.changeRightPage('chat');
      this.switchChat({chatId});
    }
  }
};
</script>

<style lang="stylus" scoped>
.unread-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0.2rem;
}
</style>
